import Layout from '@/views/Layout.vue'
import Dashboard from '@/views/Dashboard.vue'

export default {
    path: '/transit',
    component: Layout,
    children: [
        {
            path: '',
            name: 'transit.list',
            component: Dashboard
        },
        {
            path: 'register',
            name: 'transit.register',
            component: () => import('@/views/Registration.vue')
        },
        {
            path: 'payment/*',
            name: 'transit.payment',
            component: () => import('@/views/Payment.vue')
        },
        {
            path: '*',
            name: 'transit.project',
            component: () => import('@/views/Project.vue')
        }
    ]
}
